import styled from 'styled-components'
import { white } from '../../../../styles/colors'

export const Section = styled.section`
  background: ${white};
`
